import { sendEvent } from 'tracking/gtm'

const sendEventWrapper = (options) => {
  sendEvent({
    event: 'event',
    eventType: 'Engagement',
    objectType: 'UIElement',
    domain: 'adout',
    objectId: 'big-ass-category-picker',
    eventCategory: 'search',
    origin: {
      id: document.location.pathname + document.location.search,
      url: encodeURI(window.location.href),
    },
    ...options,
  })
}

export const trackCategoryLinkClick = (categoryName) => {
  sendEventWrapper({
    objectName: categoryName,
    eventLabel: categoryName,
    eventAction: 'big ass category link clicked',
  })
}

export const trackOpenMenuClick = () => {
  sendEventWrapper({
    objectName: 'big ass category menu opener',
    eventLabel: 'big ass category menu opener',
    eventAction: 'big ass category menu opener clicked',
  })
}
